import { ADD_ONEBET, GET_CURRENT_BETTING, SET_MUILT, SET_MAX_VALUE, SET_DELAY, SAMEMARKETALLOW, SET_LIVE_MULTI_ALLOW } from './types';
import store from '../store';
import axios from 'axios';
import { api_url } from '../cores/keys';
import { getMarketDetail, getBetCard, isEmpty, showMessage, toastr, convertGameSetting, getMarketRate, fixedNumber } from '../cores';
import { getUserInfo, logoutUser } from './userActions';
import { GetBettingHistories } from './moreAction';
import { SetPageLoading } from './pageAction';
import { RemoveLocal } from '../../utils';

export const GetCurrentBettingList = (sportType, type) => dispatch => {

   axios.post(api_url + '/api/Bettings/history/current', { sportType, type })
      .then(response => {
         // console.log(response.data);
         dispatch({
            type: GET_CURRENT_BETTING,
            payload: response.data.bets
         })
      })
      .catch(err => {
         console.error('err: ', err);
         if (err.response && err.response.status === 401) {
            dispatch(logoutUser());
         }
      })
}

export const CancelBetting = (id, type) => dispatch => {

   // console.log(id, type);
   const perPage = store.getState().page.perPage;
   const curPage = store.getState().page.curPage;

   axios.post(api_url + '/api/Sports/cancel', {
      type: 'toto',
      id: id
   })
      .then(res => {
         showMessage(res.data.message);
         if (!res.data.status)
            dispatch(GetBettingHistories({
               type,
               page: curPage,
               perPage: perPage
            }))
      })
      .catch(err => {
         console.error('err: ', err);
         if (err.response && err.response.status === 401)
            dispatch(logoutUser());
      })

}

export const ClearBetStore = () => dispatch => {
   const bet = store.getState().bet;
   dispatch({
      type: ADD_ONEBET,
      payload: {
         ...bet,
         sportId: 0,
         eventKey: "",
         bettedItems: [],
      }
   })
}

// export const AddOneBetGame = (data) => dispatch => {

//    const { eventKey, bettedItems, maxLength } =
//       store.getState().bet;

//    // console.log(data, bettedItems);

//    let multiBetting = store.getState().bet.multiBetting;
//    let flag = 0;
//    // console.log(store.getState().bet)

//    multiBetting.forEach(item => {
//       let val1, val2;
//       val1 = item.type.split("_")[0];
//       val2 = item.type.split("_")[1];
//       //  console.log(val1)
//       //  console.log(val2)
//       //  console.log(data.market.name_kor.includes(val1), bettedItems.findIndex(item => item.marketName.includes(val2)) > -1)
//       //  console.log(data.market.name_kor.includes(val2), bettedItems.findIndex(item => item.marketName.includes(val1)) > -1)
//       if (
//          (data.market.name_kor.includes(val1) && (bettedItems.findIndex(item => item.marketName.includes(val2)) > -1) && (bettedItems.findIndex(item => (item.eventKey === data.fixture.key)) >= 0))
//          ||
//          (data.market.name_kor.includes(val2) && (bettedItems.findIndex(item => item.marketName.includes(val1)) > -1) && (bettedItems.findIndex(item => (item.eventKey === data.fixture.key)) >= 0))
//       ) {
//          console.log("-------------------")
//          flag = 1;
//       }
//    })
//    if (bettedItems.length >= maxLength) return 0;

//    if (flag === 1) return 0;

//    if (
//          ((data.bet.data[data.index].Status !== 1) ||
//             (!data.bet.data[data.index].Id) ||  // unactivable
//             //  (eventKey && eventKey !== data.fixture.key) || // different event
//             (bettedItems.findIndex(item => (item.betId === data.bet.data[data.index].Id)&& (item.eventKey === data.fixture.key)) >= 0) ||  // betted
//             (bettedItems.findIndex(item => (item.verifyId === data.bet.data[0].Id)&& (item.eventKey === data.fixture.key)) >= 0) || // double
//             (bettedItems.findIndex(item => (item.verifyId === data.verifyId)&& (item.eventKey === data.fixture.key)) >= 0)) &&
//          (bettedItems.findIndex(item => (item.eventKey === data.fixture.key)&& (item.eventKey === data.fixture.key)) >= 0)  // different event
//       )
//       return 0;
//       console.log(data.fixture)

//    dispatch({
//       type: ADD_ONEBET,
//       payload: {
//          sportId: isEmpty(data.fixture.Fixture.League.sport) ? '' : data.fixture.Fixture.League.sport.Id,
//          eventKey: data.fixture.key,
//          bettedItems: [
//             ...bettedItems,
//             {
//                sportId: isEmpty(data.fixture.Fixture.League.sport) ? '' : data.fixture.Fixture.League.sport.Id,
//                eventKey: data.fixture.key,
//                marketName: data.market.name_front,
//                marketId: data.market.Id,
//                betId: data.bet.data[data.index].Id,
//                baseline: isEmpty(data.bet.data[data.index]) ? "" : data.bet.data[data.index].BaseLine,
//                Line: isEmpty(data.bet.data[data.index]) ? "" : data.bet.data[data.index].Line,
//                betName: data.fixture.Fixture.Participants[(data.index !== 0 ? 1 : 0)].name_front,
//                verifyId: isEmpty(data.verifyId) ? data.bet.data[0].Id : data.verifyId,
//                price: data.bet.data[data.index].Price,
//                gameType: store.getState().page.pageInfo.gameType
//             }
//          ],
//          multiBetting: multiBetting
//       }
//    })

//    return 1;
// }

export const AddOneBet = (data) => dispatch => {
   // console.log(data);
   const { bettedItems } = store.getState().bet;
   // console.log('bettedItems: ', bettedItems);
   const { pageInfo } = store.getState().page;
   // console.log(pageInfo);
   const { bet_setting } = store.getState().sports;

   const { index, bet, betList, Fixture, market } = data
   let { eventKey } = data
   if (isEmpty(eventKey)) eventKey = store.getState().sports.activeId;
   // console.log('eventKey: ', eventKey);

   // console.log(data, bettedItems, eventKey);
   // const eventKey = store.getState().sports.activeId
   // console.log(store.getState().sports.activeId);
   // console.log("store.getState().bet", store.getState().bet);
   let multiBettings = [];
   let maxLengths = [];
   let maxBetRates = [];
   let bet_multis = [];
   let currentSportId = "";
   const { sameMarketAllow, liveMultiAllow } = store.getState().bet;

   if (pageInfo.sportType === "esport") {
      const { multiBetting, maxLength, maxBetRate, bet_multi } =
         store.getState().bet;
      multiBettings = pageInfo.gameType === "prematch" ? multiBetting.esport : multiBetting.esportlive;
      maxLengths = maxLength.esport;
      maxBetRates = maxBetRate.esport;
      bet_multis = bet_multi.esport;
      currentSportId = Fixture.League.sport.oddsId;
   } else if (pageInfo.sportType === "sport") {
      const { multiBetting, maxLength, maxBetRate, bet_multi } =
         store.getState().bet;
      multiBettings = pageInfo.gameType === "live" ? multiBetting.sportlive : (pageInfo.prematchType === "interior" ? multiBetting.interior : multiBetting.sport);
      maxLengths = maxLength.sport;
      maxBetRates = pageInfo.prematchType === "interior" ? maxBetRate.interior : maxBetRate.sport;
      bet_multis = pageInfo.prematchType === "interior" ? bet_multi.interior : (pageInfo.gameType == "live" ? bet_multi.sportlive :  bet_multi.sport);
      currentSportId = Fixture.League.sport.Id;
   }
   // console.log(' store.getState().bet.multiBettings: ',  store.getState().bet.multiBetting);
   // console.log('multiBetting: ', multiBetting);
   if (isEmpty(multiBettings)) return;
   const multiBetting = multiBettings.filter(setting => setting.type == currentSportId)[0].value;
   const maxLength = maxLengths.filter(setting => setting.type == currentSportId)[0].value.value;
   const maxBetRate = maxBetRates.filter(setting => setting.type == currentSportId)[0].value.value;
   const bet_multi = bet_multis.filter(setting => setting.type == currentSportId)[0].value.value;
   // console.log('multiBetting: ', multiBetting, currentSportId);

   //-----------멀티배팅 제한---------------------
   let flag = 0;

   //---------------------------배당률 최대값 제한--------------------------------------------
   let price = 1;
   let bonusRate = 1;
   if (pageInfo.pageType === "virtual") {
      bettedItems.forEach(element => {
         // console.log(getMarketRate(element))
         price = price * getMarketRate(element);
      });
   } else {
      const betLength = betList.length;
      bet_setting.forEach(setting => {
         if (betLength >= Number(setting.fold)) {
            bonusRate = Number(setting.value);
         }
      })
      bettedItems.forEach(element => {
         let type = pageInfo.sportType === "esports" ? "esports" : pageInfo.gameType
         let card = getBetCard(element, type);
         // console.log( getBetCard(element, type), card)
         price = price * Number(card.rate);
         //   console.log(price)
      });
   }
   // console.log(data,maxBetRate, price);
   if ((price * fixedNumber(data.bet.Price[0].Price) * bonusRate) > Number(maxBetRate)) {
      toastr.warning(`최대배당율 초과되었습니다.`);
      return 0;
   }
   //------------------------------------------------------------------------

   //--------------------------------조합배팅 불가인가 ----------------------------------------
   // console.log("----------------------------------");
   // console.log('bet_multi && bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0: ', bet_multi, bet_multi && bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0);
   if (bet_multi == 1 && bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0) {
      toastr.warning(`조합배팅 불가 입니다.`);
      return 0;
   }
   //------------------------------------------------------------------------

   // console.log(store.getState().bet)
   // console.log("-------------------", "item", multiBetting)
   multiBetting.forEach(item => {
      // console.log('item: ', item);
      let val1, val2;
      val1 = convertGameSetting(item.type.split("_")[0]);
      val2 = convertGameSetting(item.type.split("_")[1]);

      // if((bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0)){
      //    if (
      //       (market.name.toLowerCase().includes(val1) && 
      //       (bettedItems.findIndex(item => item.market.name.toLowerCase().includes(val2)) > -1))
      //       ||
      //       (market.name.toLowerCase().includes(val2) && 
      //       (bettedItems.findIndex(item => item.market.name.toLowerCase().includes(val1)) > -1))
      //    ) {
      //       // console.log("-------------------", 
      //       // (market.name.toLowerCase().includes(val1) && (bettedItems.findIndex(item => item.market.name.toLowerCase().includes(val2)) > -1) && (bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0)),
      //       // (market.name.toLowerCase().includes(val2) && (bettedItems.findIndex(item => item.market.name.toLowerCase().includes(val1)) > -1) && (bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0)))
      //       toastr.warning(`${item.type.split("_")[0]} + ${item.type.split("_")[1]} 조합배팅 불가입니다.`)
      //       // toastr.warning(`중복된 마켓이 존재합니다.`);
      //       return flag = 1;
      //    }
      // }
      if (
         (market.name.toLowerCase().includes(val1) &&
            (bettedItems.findIndex(item => (item.market.name.toLowerCase().includes(val2)) && (item.eventKey === eventKey)) > -1))
         ||
         (market.name.toLowerCase().includes(val2) &&
            (bettedItems.findIndex(item => (item.market.name.toLowerCase().includes(val1)) && (item.eventKey === eventKey)) > -1))
      ) {
         // console.log("-------------------", 
         // (market.name.toLowerCase().includes(val1) && (bettedItems.findIndex(item => item.market.name.toLowerCase().includes(val2)) > -1) && (bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0)),
         // (market.name.toLowerCase().includes(val2) && (bettedItems.findIndex(item => item.market.name.toLowerCase().includes(val1)) > -1) && (bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0)))
         toastr.warning(`${item.type.split("_")[0]} + ${item.type.split("_")[1]} 조합배팅 불가입니다.`)
         return flag = 1;
      }
   })
   if (bettedItems.length >= maxLength) {
      toastr.warning(`최대배팅갯수가 초가되었습니다.`);
      return 0;
   }

   if (flag === 1) {
      // toastr.warning(`선택한 배팅은 조합배팅을 할수 없습니다.`);
      return 0;
   }

   if (!sameMarketAllow && (bettedItems.findIndex(item => (item.eventKey === eventKey) && (item.betList.marketId === market.Id)) >= 0)) {
      toastr.warning(`같은 마켓에 대해서는 한번만 배팅하실수 있습니다.`);
      return 0;
   }
   //---------------------------------------------------------------------


   // console.log("-------------------", bettedItems, data)
   if (// ((data.bet.data[data.index].Status !== 1) ||
      (
         // (!bet.Id) ||  // unactivable
         //  (eventKey && eventKey !== data.Fixture.key) || // different event
         (bettedItems.findIndex(item => (item.betId === bet.Id) && (item.eventKey === eventKey)) >= 0) ||  // betted
         (bettedItems.findIndex(item =>
            (item.betList.verifyId === betList.special) && (item.eventKey === eventKey) && (item.betList.marketId === market.Id)) >= 0) || // double
         (bettedItems.findIndex(item => (item.betList.verifyId === betList.data[0].Id) && (item.eventKey === eventKey) && (item.betList.marketId === market.Id)) >= 0)) &&
      (bettedItems.findIndex(item => (item.eventKey === eventKey)) >= 0)  // different event
   ) {
      toastr.warning(`같은 마켓에 대해서는 한번만 배팅하실수 있습니다.`);
      return 0;
   }
   localStorage.setItem("eventkey", eventKey)
   localStorage.setItem("sportsId", currentSportId)
   // console.log(data.Fixture)
   dispatch({
      type: ADD_ONEBET,
      payload: {
         sportId: isEmpty(Fixture.League.sport) ? '' : Fixture.League.sport.Id,
         eventKey: store.getState().sports.activeId,
         bettedItems: [
            ...bettedItems,
            {
               ...data,
               betList: {
                  ...betList,
                  verifyId: isEmpty(betList.special) ? betList.data[0].Id : betList.special
               },
               gameType: store.getState().page.pageInfo.gameType,
               betId: bet.Id,
               eventKey: eventKey,
            }
         ],
         multiBetting: store.getState().bet.multiBetting
      }
   })

   return 1;
}

export const AddOneBetGame = (data) => dispatch => {
   const { eventKey, bettedItems, maxLength } =
      store.getState().bet;

   let multiBetting = store.getState().bet.multiBetting;

   if (bettedItems.length > 0) //벳게임 조합배팅 금지
      return 0;

   // if ( bettedItems.findIndex(item => item.eventKey === data.eventKey) >= 0 ) //벳게임 한경기내에서 조합배팅 금지
   //    return 0;

   // if ( bettedItems.findIndex(item => item.marketId === data.marketId) >= 0 ) // 벳게임에서 조합배팅을 할때 같은 마켓에서 배팅금지
   //    return 0;

   // if ( (bettedItems.findIndex(item => (item.eventKey === data.eventKey) && (item.cate1 === data.cate1)) >= 0) && data.cate1 === "oneteam" ) // 원팀일때 배팅제한
   //    return 0;
   dispatch({
      type: ADD_ONEBET,
      payload: {
         eventKey: data.eventKey,
         bettedItems: [
            ...bettedItems,
            {
               ...data,
               ...store.getState().page.pageInfo,
               eventKey: data.eventKey,
            }
         ],
         multiBetting: multiBetting
      }
   })

   return 1;
}

export const RemoveOneBet = (data) => dispatch => {
   // console.log("-------------------",data)
   let multiBetting = store.getState().bet.multiBetting;

   const { bettedItems, sportId, eventKey } = store.getState().bet;
   const index = bettedItems.findIndex(item => item.betId === data);
   if (index < 0) return 0;
   if (bettedItems.length === 1) {
      dispatch(ClearBetStore());
      localStorage.removeItem("bettingItem")
   }
   else {
      dispatch({
         type: ADD_ONEBET,
         payload: {
            sportId, eventKey,
            bettedItems: bettedItems.slice(0, index)
               .concat(bettedItems.slice(index + 1, bettedItems.length)),
            multiBetting: multiBetting
         }
      })
   }

   return 1;
}

export const DoBetting = (data, type) => dispatch => {
   const { sportId, eventKey, bettedItems, delaySetting, liveMultiAllow } = store.getState().bet;
   //console.log('liveMultiAllow: ', liveMultiAllow);
   const { pageInfo } = store.getState().page;
   //console.log('liveMultiAllow: ', liveMultiAllow,pageInfo.gameType);

   // console.log(bettedItems, type);

   if (((pageInfo.gameType === "live") && liveMultiAllow) && (bettedItems.length === 1)) {
      return toastr.warning(`단폴더 배팅은 불허되어있습니다.`);
   }

   let fixedBettedItems = [];
   bettedItems.forEach(element => {
      fixedBettedItems.push(getBetCard(element, type)
         // { 
         //    sportId: element.sportId,
         //    eventKey: element.eventKey,
         //    market_id: element.marketId,
         //    provider_id: element.providerId,
         //    bet_id: element.betId,
         //    market_name: element.marketName,
         //    odd_name: element.betName
         // }
      )
   });

   dispatch(SetPageLoading(true));

   // //console.log('pageInfo.sportType: ', pageInfo.sportType, pageInfo.gameType, delaySetting);
   const getTimeOutSetting = () => {
      if (pageInfo.sportType === "sport") {
         if (pageInfo.gameType === "prematch") {
            return delaySetting[0].value
         }
         else {
            return delaySetting[1].value
         }
      }
      else if (pageInfo.sportType === "esport") {
         if (pageInfo.gameType === "prematch") {
            return delaySetting[2].value
         }
         else {
            return delaySetting[3].value
         }
      }
      else {
         return 0;
      }

   }
   const timeOutSetting = Number(getTimeOutSetting()) * 1000;
   // //console.log('timeOutSetting: ', timeOutSetting);

   setTimeout(() => {
      dispatch(ClearBetStore());
      axios.post(api_url + `/api/${type !== "virtual" ? "Sports" : "Betgame"}/betting`,
         {
            sportId: sportId,
            eventKey: eventKey,
            bets: fixedBettedItems,
            amount: data,
            national_type: type === 'interior' ? 1 : 0,
            type: type === 'prematch' ? "prematch" : (type === 'interior' ? "home_prematch" : "")
         }
      )
         .then(res => {
            dispatch(SetPageLoading(false));
            showMessage(res.data.message);
            RemoveLocal();
            dispatch(getUserInfo());
            // dispatch(GetCurrentBettingList(
            //    pageInfo.pageType === 'virtual' ? 'betgame' : pageInfo.sportType,
            //    pageInfo.pageType === 'virtual' ? pageInfo.sportType : pageInfo.gameType
            // ));
         })
         .catch(err => {
            console.error('err: ', err);
            dispatch(SetPageLoading(false));
            if (store.getState().user.isAuthenticated)
               return dispatch(logoutUser());
            if (err.response && err.response.status === 401) {
               return dispatch(logoutUser());
            }
            else {
               return toastr.warning('배팅이 실패되었습니다.');
            }
         })
   }, timeOutSetting)

}


export const setMulti = (data) => dispatch => {
   dispatch({
      type: SET_MUILT,
      payload: data,
   })
}


export const setMaxVal = (data) => dispatch => {
   dispatch({
      type: SET_MAX_VALUE,
      payload: data,
   })
}


export const setDelaySetting = (data) => dispatch => {
   dispatch({
      type: SET_DELAY,
      payload: data,
   })
}


export const setSameMarketAllow = (data) => dispatch => {
   dispatch({
      type: SAMEMARKETALLOW,
      payload: data,
   })
}


export const setLiveMultiAllow = (data) => dispatch => {
   dispatch({
      type: SET_LIVE_MULTI_ALLOW,
      payload: data,
   })
}


// WEBPACK FOOTER //
// ./src/common/actions/betAction.js